import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const BlogSection = () => {
  const blogContent = [
    {
      subTitle: "finance",
      date: "5 Feb , 2022",
      title: "10 Marketing Trends That You Should Be Prepared for in 2022",
      content:
        "The goal of this new editor is to make adding rich content to WordPress simple…",
    },
    {
      subTitle: "finance",
      date: "18 Feb , 2022",
      title: "Expanding the Global NFT Ecosystem: A Preview of...",
      content:
        "The goal of this new editor is to make adding rich content to WordPress simple…",
    },
    {
      subTitle: "finance",
      date: "25 Feb , 2022",
      title: "OpenSea Acquires Gem to Invest in Pro Experience",
      content:
        "The goal of this new editor is to make adding rich content to WordPress simple…",
    },
    {
      subTitle: "finance",
      date: "1 March , 2022",
      title: "10 Marketing Trends That You Should Be Prepared for in 2022",
      content:
        "The goal of this new editor is to make adding rich content to WordPress simple…",
    },
    {
      subTitle: "finance",
      date: "25 Feb , 2022",
      title: "OpenSea Acquires Gem to Invest in Pro Experience",
      content:
        "The goal of this new editor is to make adding rich content to WordPress simple…",
    },
    {
      subTitle: "finance",
      date: "18 Feb , 2022",
      title: "Expanding the Global NFT Ecosystem: A Preview of...",
      content:
        "The goal of this new editor is to make adding rich content to WordPress simple…",
    },
  ];
  return (
    <div className="blog-section section-padding" id="blog">
      <div className="container">
        <div className="row pb-5">
          <div className="col-lg-4 col-sm-8 col-12 mx-auto">
            <div className="blog-title text-center">
              <h2 className="text-white md-sm-5 mb-4" data-aos='fade-up' >Financial News</h2>
              <p data-aos='fade-up' >
                Here Are The Best Features That Makes Xhibiter The Most
                Powerful, And Fast.
              </p>
            </div>
          </div>
        </div>
        <div className="row g-4 d-flex align-items-center mt-5 align-items-stretch">
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            navigation={true}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              572: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            modules={[Navigation, Autoplay]}
            className="mySwiper"
          >
            {blogContent.map((element, index) => {
              return (
                <SwiperSlide key={index} className="my-5" data-aos='fade-up' >
                  <div className="blog-card p-sm-5 p-4 ">
                    <div className="blog-header d-flex align-items-center gap-4">
                      <p className="blog-subtitle">{element.subTitle}</p>
                      <p className="date">{element.date}</p>
                    </div>
                    <div className="blog-body">
                      <a href="#" className=" mb-md-5 mb-4">{element.title}</a>
                      <p>{element.content}</p>
                      <p className="mt-sm-5 mt-4 blog-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
            {/* <SwiperSlide>Slide 2</SwiperSlide>
        <SwiperSlide>Slide 3</SwiperSlide>
        <SwiperSlide>Slide 4</SwiperSlide> */}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
